const getLocalDataKey = (activeStepNr: number) => `onboarding_wizard_step_${activeStepNr}_data`;

export const setLocalData = (userId: number | undefined, activeStepNr: number, rows?: unknown[]) => {
  const localStorage = window.localStorage;
  if (!localStorage) return;
  const localDataKey = getLocalDataKey(activeStepNr);
  if (rows) {
    const data = {rows: rows, userId: userId, validUntil: Date.now() + 1000 * 60 * 60 * 24}; // 24 hours
    localStorage.setItem(localDataKey, JSON.stringify(data));
  } else {
    localStorage.removeItem(localDataKey);
  }
};

export const getLocalData = (userId: number, activeStepNr: number) => {
  const localStorage = window.localStorage;
  if (!localStorage) return;
  const localDataKey = getLocalDataKey(activeStepNr);
  const data = localStorage.getItem(localDataKey);
  if (!data) return;
  const parsedData = JSON.parse(data);
  if (parsedData.validUntil > Date.now() && parsedData.userId === userId) {
    return parsedData.rows;
  } else {
    localStorage.removeItem(localDataKey);
    return;
  }
};
